import { Box, styled } from '@/shared/ui/mui';
/**
 * ShopMediaWrapper - Wrapper component for shop card media/images
 *
 * A simple wrapper that provides consistent positioning and overflow
 * handling for media elements in shop cards.
 *
 * @example
 * ```tsx
 * <ShopMediaWrapper>
 *   <CardMedia component="img" image={shop.imageUrl} alt={shop.name} />
 *   <GradientOverlay />
 * </ShopMediaWrapper>
 * ```
 */
export const ShopMediaWrapper = styled(Box)(() => ({
  position: 'relative',
  height: 200,
  overflow: 'hidden',
}));
